export const readingColumns = [
  {
    field: "id",
    headerName: "Sr.No.",
    editable: false,
  },
  {
    field: "dept",
    headerName: "Department",
    editable: true,
  },
  {
    field: "contactPersonName",
    headerName: "Contact Person Name",
    editable: true,
  },

  {
    field: "contactNo",
    headerName: "Contact No",
    editable: true,
    validate: (value) => /^\d{10}$/.test(value),
    errorText: "(10 digits required)",
  },
  {
    field: "email",
    headerName: "Email Id",
    editable: true,
    validate: (value) =>
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
    errorText: "Invalid email address",
  },
];
